module.exports = __webpack_public_path__ + "static/media/curvedtrack.513c0cf6.png";